module.exports = __webpack_public_path__ + "img/Frueher-1024@2x.4d492faf.jpg";